import React from "react";
import "../css/ContentPage.css";
import short_loan from "../images/short_loan.jpg";
import { Link } from "react-router-dom";
import ChatButton from "../components/ChatButton";
import { APP_NAME } from "../Utils/constant";

const ShortLoan = () => {
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Short Term Loans</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              <div className="content_banner">
                <img src={short_loan} alt="" />
              </div>
              <h1 className="page_title mt30 mb20">Short Term Loan</h1>
              <p>
                At {APP_NAME}, we understand that financial crises can arise
                unexpectedly and often require immediate action and rapid access
                to funds. That's why we specialize in providing emergency loans
                online to give you financial support whenever you need it. Our
                emergency personal loan application process is designed to be
                efficient and easy, so you can get the money you need quickly
                and easily. Whether you're dealing with urgent medical bills,
                unexpected travel expenses, or other pressing financial needs,
                our fast online loan options can help you.
              </p>
              <br />
              <p>
                In addition to emergency loans, we also offer short-term loans
                to meet your urgent financial needs. These short-term loans
                offer easy solutions for those who need money quickly in the
                short term, helping you manage your finances without the
                responsibility of long-term commitments. We have updated the
                short-term loan process to ensure that you get the money you
                need quickly and easily. Choosing a {APP_NAME} means choosing a
                financial institution that prioritizes your financial needs
                quickly, reliably and efficiently. Our emergency loan services
                are designed to give you the peace of mind you need when it
                matters most. We understand the urgency of the financial crisis
                and our aim is to provide the necessary support as soon as
                possible.
              </p>
              <br />
              <p>
                At {APP_NAME}, you can trust our commitment to providing fast,
                reliable online emergency and short-term loans. Our dedicated
                team is working hard to ensure the success of your application
                so that you can solve your financial problems safely. one We
                pride ourselves on our transparency and customer focus; We make
                sure you understand all the terms and conditions of your loan
                and feel confident in your decision. Our online website is
                designed to streamline the loan application process and make
                getting a loan easy and convenient for all customers.
              </p>
              <br />
              <p>
                Whether you're facing unexpected debt or need quick financial
                support, {APP_NAME} has the emergency loans and short-term loan
                solutions you need. Our reliable and efficient services are
                designed to meet your urgent financial needs by offering the
                convenience and assurance of a trusted partner at {APP_NAME}. Let
                us help you manage your financial emergencies with ease and
                confidence.
              </p>
              <br />
              <div className="button_container flex justify-center">
                <Link to="/apply-now">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default ShortLoan;
